import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContainerModule } from '@app/components/container/container.module';
import { ProfileComponent } from './profile.component';
import { SharedModule } from '@shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { ProfileRoutingModule } from '@app/profile/profile-routing.module';
import { DetailsTabModule } from '@app/profile/detailsTab/detailsTab.module';
import { FriendsSurveyStatusModule } from '@app/profile/friendsSurveyStatus/friendsSurveyStatus.module';
import { CertificatesTabModule } from '@app/profile/certificatesTab/certificatesTab.module';

@NgModule({
  imports: [
    CommonModule,
    ContainerModule,
    DetailsTabModule,
    FriendsSurveyStatusModule,
    MatTabsModule,
    ProfileRoutingModule,
    SharedModule,
    CertificatesTabModule,
  ],
  declarations: [ProfileComponent],
})
export class ProfileModule {}
